export const statusRowContentLive = (scoreHome, scoreGuest, time, hasLivestream) => `        
<div class="score"><span class="host-score">${scoreHome}</span> - <span class="guest-score">${scoreGuest}</span></div>
    ${hasLivestream ? 
    ''
    :`<div class="time-wrap"> <div class="live-label">Live</div><div class="status minute">${time}</div> </div>` }
`